/* Kuk footer (sop/footer-hesap.json 3-5): aynı anda tek akordeon grubu açık (details name özniteliğini desteklemeyen
   tarayıcı için), telefon satırında mesai dışı alt metni (Türkiye saati), bülten formu sayfa yenilenmeden.
   JS yoksa akordeonlar açılır, mesai satırı sabit kalır, bülten formu normal gönderilir. */
(() => {
  if (window.kukFooter) return;
  window.kukFooter = true;

  // Tek grup açık: name desteği yoksa öncekini kapat
  if (!('name' in HTMLDetailsElement.prototype)) {
    document.addEventListener('toggle', (e) => {
      const d = e.target;
      if (!(d instanceof HTMLDetailsElement) || !d.open || d.getAttribute('name') !== 'kuk-footer-menu') return;
      document.querySelectorAll('details[name="kuk-footer-menu"][open]').forEach((x) => { if (x !== d) x.open = false; });
    }, true);
  }

  // Mesai: hafta içi başlangıç-bitiş arası 'Hafta içi 09:00-18:00', dışında 'Mesai dışındayız ...'
  const mesai = () => {
    const p = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Istanbul', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
    }).formatToParts(new Date()).map((x) => [x.type, x.value]));
    const simdi = Number(p.hour) * 60 + Number(p.minute);
    const dakika = (s) => { const [a, b] = String(s).split(':').map(Number); return (a || 0) * 60 + (b || 0); };
    document.querySelectorAll('[data-kuk-mesai]').forEach((a) => {
      const ici = !['Sat', 'Sun'].includes(p.weekday) && simdi >= dakika(a.dataset.bas) && simdi < dakika(a.dataset.son);
      const icMetin = a.querySelector('[data-mesai-ici]');
      const disMetin = a.querySelector('[data-mesai-disi]');
      if (icMetin) icMetin.hidden = !ici;
      if (disMetin) disMetin.hidden = ici;
    });
  };

  // Bülten: e-posta ve onay denetimi, fetch ile gönderim; bot doğrulaması ya da beklenmeyen yanıtta normal gönderim
  const bultenHazirla = () => {
    document.querySelectorAll('form[data-kuk-bulten]').forEach((f) => { f.noValidate = true; });
  };
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-kuk-bulten]');
    if (!form) return;
    e.preventDefault();
    const eposta = form.querySelector('input[type="email"]');
    const onay = form.querySelector('[data-bulten-onay]');
    if (!eposta || !onay) { form.submit(); return; }
    const gecerli = eposta.value.trim() !== '' && eposta.checkValidity();
    form.querySelector('[data-bulten-hata]').hidden = gecerli;
    eposta.classList.toggle('is-hatali', !gecerli);
    form.querySelector('[data-bulten-onay-hata]').hidden = onay.checked;
    form.querySelector('[data-bulten-onay-satir]').classList.toggle('is-hatali', !onay.checked);
    if (!gecerli) { eposta.focus(); return; }
    if (!onay.checked) { onay.focus(); return; }
    const dugme = form.querySelector('button[type="submit"]');
    if (dugme.classList.contains('is-yukleniyor')) return;
    dugme.classList.add('is-yukleniyor');
    try {
      const yanit = await fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } });
      if (yanit.url.includes('/challenge')) { form.submit(); return; }
      const belge = new DOMParser().parseFromString(await yanit.text(), 'text/html');
      const yeni = belge.getElementById(form.id);
      const basari = yeni && yeni.querySelector('[data-bulten-basari]');
      if (basari) {
        form.querySelector('[data-bulten-satir]').replaceWith(basari);
        form.querySelectorAll('[data-bulten-hata], [data-bulten-onay-hata]').forEach((h) => { h.hidden = true; });
        form.classList.add('is-gonderildi');
        window.kukOrtak?.olay('bulten_kaydi', { kaynak: 'footer' });
      } else if (yeni && yeni.querySelector('[data-bulten-hata]:not([hidden])')) {
        form.querySelector('[data-bulten-hata]').hidden = false;
        eposta.classList.add('is-hatali');
        eposta.focus();
      } else {
        form.submit();
      }
    } catch (hata) {
      form.submit();
    } finally {
      dugme.classList.remove('is-yukleniyor');
    }
  });

  const baslat = () => { mesai(); bultenHazirla(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', baslat);
  else baslat();
  setInterval(mesai, 60000);
})();
